import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd';
import { TITLE } from 'src/app/utils/enum';
import { floatToStringFormat, stringFormatToFloat } from '../../../../fieldTypes/TextFields';
import { FormFieldInfo } from '../../../../models/forms-response.models';

@Component({
    selector: 'app-component-text-checkbox',
    templateUrl: './text-checkbox.component.html',
    styleUrls: ['./text-checkbox.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextCheckboxComponent implements OnInit, OnChanges, AfterContentChecked {
    @Input() formFieldInfo: FormFieldInfo;
    @Input() formGroup: FormGroup;
    @Input() modalTitle:any;
    @Input() formData: any;
    formFieldConfig: any;
    fieldConfig: any;
    isRequired: boolean;
    name: string;
    hideTitle: boolean;
    checked: boolean;
    isNumeric: boolean;
    maxlength = 0;
    keydownPattern: string;
    onchangePattern: string;
    formFieldConfigPattern: any;
    onchangePatternFormField: any;
    keydownPatternFormField: any;
    value: string
    isError: string;
    fieldCode: string;
    tooltip: string;
    fieldDataInfo:any;
    taxCode="";
    formCode="";

    constructor(private nzModalNotification: NzNotificationService, private cdref: ChangeDetectorRef) { }

    ngOnChanges() {}

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit(): void {
        try {
            this.formFieldConfig = this.formFieldInfo.formFieldConfig ? JSON.parse(this.formFieldInfo.formFieldConfig) : "";
            this.fieldConfig = this.formFieldInfo.fieldConfig ? JSON.parse(this.formFieldInfo.fieldConfig) : "";
            this.fieldCode = this.formFieldInfo.fieldCode;
            this.fieldDataInfo=this.formFieldInfo;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            this.name = (this.formFieldConfig && this.formFieldConfig.displayText) ? this.formFieldConfig.displayText : this.formFieldInfo.name;
            this.hideTitle = (this.formFieldConfig && this.formFieldConfig.hideTitle) ? this.formFieldConfig.hideTitle : false;
            if (this.formFieldConfig) {
                this.formFieldConfigPattern = this.formFieldConfig.pattern ? this.formFieldConfig.pattern : "";
                this.onchangePatternFormField = this.formFieldConfigPattern.onchangePattern ? this.formFieldConfigPattern.onchangePattern : "";
                this.keydownPatternFormField = this.formFieldConfigPattern.keydownPattern ? this.formFieldConfigPattern.keydownPattern : "";
            }

            if (this.fieldConfig) {
                this.isNumeric = this.fieldConfig.isNumeric ? this.fieldConfig.isNumeric : false;
                this.maxlength = this.fieldConfig.maxlength ? this.fieldConfig.maxlength : "";
                this.onchangePattern = this.fieldConfig.onchangePattern ? this.fieldConfig.onchangePattern : "";
                this.keydownPattern = this.fieldConfig.keydownPattern ? this.fieldConfig.keydownPattern : "";
            }
            this.formCode=localStorage.getItem('FORM_CODE');
            this.taxCode=localStorage.getItem('TAXCODE');
            this.tooltip = this.formFieldConfig && this.formFieldConfig.tooltip ? this.formFieldConfig.tooltip : "";
            this.bindingData();
        } catch (error) {
            this.formFieldConfig = JSON.parse('{ "pattern": "" }');
            this.fieldConfig = JSON.parse('{ "keydownPattern": "" }');
        }
    }

    bindingData(){
        if (this.modalTitle == TITLE.ADD_DATA)//This case is: Click icon(+) to open popup
        {
            this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
            this.checked = false;
        }
        else if (this.modalTitle == TITLE.UPDATE_DATA) { //This case is: Click icon(edit) to open popup
            if (this.formData) {
                let objectData = this.formData;
                const keys = Object.keys(objectData);
                keys.forEach((key) => {
                    if (key == this.formFieldInfo.fieldCode) {
                        let value = objectData[key];
                        this.value = value;
                        this.checked = (this.value == 'true') ? true : false;
                    }
                });
            }
        }
        else {
            let storageVal = localStorage.getItem("VALUE_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_' + this.fieldCode);
            this.checked = localStorage.getItem("VALUE_CHECKBOX_" + this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode) == "true" ? true : false;
            if (storageVal) {
                this.value = storageVal ? storageVal : '';
            } else if (this.formData && this.formData[this.fieldCode]) {
                this.value = this.formData[this.fieldCode];
            } else {
                this.value = (this.formFieldConfig && this.formFieldInfo.defaultValue) ? this.formFieldInfo.defaultValue : '';
            }
        }
    }


    onChangeValidateText() {
        var validate = true;
        var message = "";
        var onchangePattern = this.fieldConfig.onchangePattern;

        //check validate format 
        if (onchangePattern) {
            var patternFieldConfig = new RegExp(onchangePattern);
            if (!patternFieldConfig.test(this.value) && this.value) {
                validate = false;
                message = " Sai định dạng format";
                this.nzModalNotification.error("Cảnh báo", "Chuỗi " + message);
            }
        }

        if (this.isNumeric) {
            var number: any = stringFormatToFloat(this.value);
            if (isNaN(number) || number == "") {
                validate = false;
                message = " Sai định dạng format";
            } else {
                var valueNumeric = floatToStringFormat(number);
                this.value = valueNumeric
            }
        }

        if (validate == false) {
            this.isError = "error";
        }

        localStorage.setItem("VALUE_" +  this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+this.fieldCode, this.value);
        localStorage.setItem("VALUE_CHECKBOX_" +  this.formFieldInfo.formCode +'_'+ this.taxCode + '_'+ this.fieldCode, this.checked ? "true" : "false");
    }

    onkeydownValidateText() {
        let message = "";
        let validate = true;
        var number: any;
        var keydownPattern = this.fieldConfig.keydownPattern;

        if (this.maxlength && this.value && this.value.length >= this.maxlength) {
            return;
        } else {
            if (this.isNumeric) {
                number = stringFormatToFloat(this.value);
                if (isNaN(number) || number) {
                    validate = false;
                    message = " Sai định dạng format";
                } else {
                    var valueNumeric = floatToStringFormat(number);
                    this.value = valueNumeric;
                }
            }

            //check validate format 
            if (keydownPattern) {
                var patternFieldConfig = new RegExp(keydownPattern);
                if (!patternFieldConfig.test(this.value) && this.value) {
                    validate = false;
                    message = " Sai định dạng format";
                }
            }

            //result of validate
            if (!validate) {
                this.nzModalNotification.error("Cảnh báo", "Chuỗi " + message);
                // $("#btn_save").unblock();
                this.isError = "error";
                return true;
            }
        }
    }
}